export { GuestDetailsConnected as GuestDetails } from './container';
